export default __webpack_public_path__ + "static/media/visa-colored.de2b6229.svg";